<template>
  <div class="event-module">
    <component v-bind:is="currentComponent" :data="itemInfo"></component>
  </div>
</template>
<script>
import typeLists from '../../config/eventType'

export default {
  name: 'event-module',
  props: {
    itemInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    currentComponent () {
      return typeLists.eventTypeList[this.itemInfo.type]
    }
  }
}
</script>
